import {
  CheckMetadata,
  CheckMetadataItem,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import RiskLevelSticker from 'dashboard/components/RiskLevelSticker';
import { SelfieAgeInconsistencyDetection } from 'dashboard/models/check';

export const computeSelfieAgeInconsistencyDetectionMetadata = (
  check: SelfieAgeInconsistencyDetection,
): CheckMetadata => {
  let metadata = [] as CheckMetadataItem[];
  if (check.metadata && check.reasons) {
    const {
      age,
      'age-range-low': ageRangeLow,
      'age-range-high': ageRangeHigh,
      'reference-age': referenceAge,
      'risk-level': riskLevel,
    } = check.metadata || {};

    if (riskLevel) {
      const metadataItems = [
        {
          label: 'Age Inconsistency Detection Risk',
          value: RiskLevelSticker({ riskLevel: riskLevel }),
        },
      ] as Array<{ label: string; value: React.ReactNode }>;

      if (age) {
        metadataItems.push({ label: 'Estimated Age', value: `${age.toFixed(2)} years old` });
      } else {
        if (ageRangeLow) {
          metadataItems.push({
            label: 'Estimated Age Lower Bound',
            value: `${ageRangeLow} years old`,
          });
        }
        if (ageRangeHigh) {
          metadataItems.push({
            label: 'Estimated Age Upper Bound',
            value: `${ageRangeHigh} years old`,
          });
        }
      }

      if (referenceAge) {
        metadataItems.push({
          label: 'Reference Age',
          value: `${referenceAge.toFixed(2)} years old`,
        });
      }

      metadata = createSimpleCheckMetadataArray(metadataItems);
    }
  }

  return {
    metadata,
    hideIfVerificationPassed: false,
  };
};
